import { format } from "date-fns";
import { Link } from "react-router-dom";
import { useDeleteNoteMutation } from '../notesApiSlice'


export default function NoteRow({ note }) {
    const [deleteNote, { isLoading }] = useDeleteNoteMutation();

    const created = note.createdAt ? format(new Date(note.createdAt), "yyyy-MM-dd") : "—";

    const handleDelete = async () => {
        try {
            await deleteNote({ id: note._id }).unwrap()
            alert(`Note '${note.title}' deleted successfully`)
        } catch (err) {
            console.error("Delete error:", err)
            alert(err?.data?.message || "Failed to delete note")
        }
    }

    return (
        <tr className="hover:bg-gray-50/40">
            <td className="px-6 py-3 text-sm text-gray-900 font-medium">{note.title}</td>
            <td className="px-6 py-3 text-sm text-gray-600">{note.shortTitle || "—"}</td>
            <td className="px-6 py-3">
                {note.status === "open" ? (
                <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700 ring-1 ring-inset ring-emerald-200">
                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500"></span> open
                </span>
                ) : (
                <span className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2.5 py-1 text-xs font-medium text-rose-700 ring-1 ring-inset ring-rose-200">
                    <span className="h-1.5 w-1.5 rounded-full bg-rose-500"></span> closed
                </span>
                )}
            </td>
            <td className="px-6 py-3 text-sm text-gray-600">{created}</td>
            <td className="px-6 py-3 text-right">
                <div className="inline-flex gap-2">
                <Link
                    to={`/dash/notes/${note._id}`}  
                    className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
                >
                    Edit
                </Link>
                <button
                    onClick={handleDelete}
                    disabled={isLoading}
                    className="rounded-xl border border-gray-200 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
                >
                    {isLoading ? "Deleting..." : "Delete"}
                </button>
                </div>
            </td>
        </tr>
    );
}
